<!-- eslint-disable vue/no-reserved-component-names -->
<template>
    <div v-if="$state.showApp" id="app">
        <Layout>
            <div v-if="validBroker" class="container">
                <ValidationObserver v-slot="{ validate }">
                    <Step :current-step="currentStep" :show-step4="showStep4" />
                    <div class="mt-2">
                        <PolicyHolder
                            v-if="currentStep === 1"
                            :go-to-next-step="goToNextStep"
                            :is-collapse="isCollapse"
                        />

                        <EvolutionHealth
                            v-if="currentStep === 2"
                            :previous-step="previousStep"
                            :go-to-next-step="goToNextStep"
                            :go-to-previous-step="goToPreviousStep"
                        />

                        <AdditionalDetails
                            v-if="currentStep === 3"
                            :go-to-next-step="goToNextStep"
                            :go-to-previous-step="goToPreviousStep"
                            :is-collapse="isCollapse"
                        />

                        <UnderwritingQuestions
                            v-if="currentStep === 4"
                            :go-to-next-step="goToNextStep"
                            :go-to-previous-step="goToPreviousStep"
                            :is-collapse="isCollapse"
                        />

                        <Summary
                            v-if="currentStep === 5"
                            :is-valid="isApplyValid"
                            :go-to-next-step="goToNextStep"
                            :go-to-previous-step="goToPreviousStep"
                            :quote-verify="quoteVerify"
                            @onScreenshot="actionScreenShot"
                            @getMemberCard="actionGetMemberCard"
                        />

                        <!-- Summary all step pdf file -->
                        <div id="pdf-preview-form">
                            <PolicyHolderSummary
                                v-if="currentStep == 5"
                                v-show="$root.showSummaryComponent"
                                id="PolicyHolderSummary"
                                :quote-verify="quoteVerify"
                            />
                        </div>

                        <!-- MemberCard pdf file -->
                        <div style="display: none">
                            <vue-html2pdf
                                ref="html2PdfMemberCard"
                                :show-layout="true"
                                :float-layout="false"
                                :enable-download="false"
                                :preview-modal="false"
                                :paginate-elements-by-height="5000"
                                :filename="`MemberCards`"
                                :pdf-quality="2"
                                :manual-pagination="false"
                                pdf-format="a4"
                                pdf-orientation="portrait"
                                pdf-content-width="auto"
                                @beforeDownload="beforeDownloadMemberCard($event)"
                            >
                                <section slot="pdf-content">
                                    <MemberCard
                                        v-if="currentStep === 5"
                                        v-show="showMemberCardComponent"
                                        :summary="summary"
                                    />
                                </section>
                            </vue-html2pdf>
                        </div>
                    </div>
                    <div id="control-btn" class="form-footer bg-footer" style="z-index: 999">
                        <div class="d-flex justify-content-center">
                            <button
                                v-show="currentStep > 1"
                                id="previousBtn"
                                class="btn btn-secondary mx-2"
                                :disabled="isDisablePrevious"
                                @click="goToPreviousStep()"
                            >
                                {{ $t('common.previousBtn') }}
                            </button>
                            <LoadingButton
                                v-show="currentStep < 5"
                                v-if="
                                    ($formData.underwritingTypeId == 1 && currentStep == 4) ||
                                    ($formData.underwritingTypeId !== 1 &&
                                        currentStep == 3 &&
                                        $formData.underwritingQuestionsCount == 0)
                                "
                                :id="'nextBtn'"
                                :title="$t('common.verifyBtn')"
                                :is-loading="isNextBtnLoading"
                                @onClick="goToNextStep(validate)"
                            />
                            <LoadingButton
                                v-else
                                v-show="currentStep < 5"
                                :id="'nextBtn'"
                                :title="$t('common.nextBtn')"
                                :is-loading="isNextBtnLoading"
                                @onClick="goToNextStep(validate)"
                            />
                        </div>
                    </div>
                </ValidationObserver>
            </div>
            <div v-else>
                <InvalidBroker />
            </div>
        </Layout>

        <div
            id="contactUsModal"
            class="modal fade"
            tabindex="-1"
            aria-labelledby="contactUsModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title fw-bold">
                            <span v-for="(item, index) in $root.t('contactUs.title')" :key="index">
                                {{ item }} <br />
                            </span>
                        </h3>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                    </div>
                    <div class="modal-body">
                        <ContactUs :form="contactUsData" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="sendContactUs()">
                            {{ $t('common.sendBtn') }}
                        </button>
                        <button type="button" class="btn btn-secondary border-secondary" data-bs-dismiss="modal">
                            {{ $t('common.closeBtn') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            id="timeOutModal"
            class="modal fade"
            tabindex="-1"
            aria-labelledby="timeOutModalLabel"
            aria-hidden="true"
            data-bs-keyboard="false"
            data-bs-backdrop="static"
            role="dialog"
        >
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title fw-bold">Timeout Error</h3>
                    </div>
                    <div class="modal-body">
                        <p>Oops! Your session has timed out.</p>

                        <p>The form you were working on was not saved. Please fill it out again.</p>

                        <p>You can also contact us for assistance.</p>
                    </div>
                    <div class="modal-footer d-flex justify-content-center">
                        <button type="button" class="btn btn-primary" @click="startOverFunction()">Start Over</button>
                    </div>
                </div>
            </div>
        </div>

        <div id="closingModal" class="modal fade" tabindex="-1" aria-labelledby="closingModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title fw-bold">Leaving this site?</h3>
                    </div>
                    <div class="modal-body">
                        <p>Please don't leave</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from './components/Layout'
import LoadingButton from './components/shared/LoadingButton.vue'
import PolicyHolder from './components/PolicyHolder/index.vue'
import AdditionalDetails from './components/AdditionalDetails/Index.vue'
import InvalidBroker from './components/Broker/InvalidBroker.vue'
import Summary from './components/ConfirmAndBuy/index.vue'
import EvolutionHealth from './components/SelectQuote/index.vue'
import UnderwritingQuestions from './components/UnderwritingQuestions/index.vue'

import ContactUs from './components/ContactUs/index.vue'

import MemberCard from './components/MemberCard/Index.vue'

import Step from './components/shared/Step.vue'

import baseApi from './api/common/baseApi.js'
import { STORAGE } from './api/common/config.js'
import quoteService from './api/services/quoteService.js'
import storage from './utils/storage.js'

import { getSummaryData, setDefaultProductFormData, setSessionFormData } from './data/formData'

import PolicyHolderSummary from './components/CustomerService/PolicyHolderSummary.vue'

import VueHtml2pdf from 'vue-html2pdf'

import applyOnlineService from './api/services/applyOnlineService'
import helper from './utils/helper.js'
import { logger } from './utils/logger.js'

export default {
    name: 'App',
    components: {
        Layout,
        LoadingButton,

        PolicyHolder,
        EvolutionHealth,
        AdditionalDetails,
        UnderwritingQuestions,
        // eslint-disable-next-line vue/no-reserved-component-names
        Summary,
        InvalidBroker,

        ContactUs,
        Step,
        PolicyHolderSummary,
        VueHtml2pdf,
        MemberCard,
    },
    data() {
        const queryParams = new URLSearchParams(window.location.search)
        let currentStep = parseInt(queryParams.get('step') || 1)

        // this.updateQueryParams({step: currentStep})

        // Deny change url if payment complete
        if (!this.$state.isApplyOrPaymentComplete) {
            if (this.$state.isSubmitFormProcessing) {
                this.$state.isSubmitFormProcessing = false
            }
            if (!this.$formData.currentStep || this.$formData.currentStep < currentStep) {
                if (!this.$formData.currentStep) {
                    currentStep = 1
                    this.$formData.currentStep = currentStep
                } else {
                    currentStep = this.$formData.currentStep
                }
                this.updateQueryParams({ step: currentStep })
            }

            if (this.$formData.currentStep > currentStep) {
                if (currentStep == 4 && this.$formData.underwritingTypeId !== 1) {
                    currentStep = 3
                }
                this.$formData.currentStep = currentStep
                this.updateQueryParams({ step: currentStep })
            }

            // Redirect to previous step if current step is specific step (in case the user is on the step and they want to refresh)
            if (this.$formData.currentStep === currentStep) {
                // Redirect to previous step if current step is final (in case the user is on final step and they want to refresh)
                if (this.$formData.currentStep === 5) {
                    if (this.$formData.underwritingTypeId === 1) {
                        currentStep = 4
                    } else {
                        currentStep = 3
                    }
                }

                // Redirect to previous step if current step is 1
                if (this.$formData.currentStep === 2) {
                    currentStep = 1
                }

                this.$formData.currentStep = currentStep
                this.updateQueryParams({ step: currentStep })
            }
        } else {
            currentStep = this.$formData.currentStep
            this.updateQueryParams({ step: currentStep })
        }

        return {
            ignoreValidation: false,
            currentStep: currentStep,
            previousStep: null,
            details: this.$formData.policyHolder.details,

            // verify Data
            productData: this.$formData.product, //product data in $formData
            isVerifyError: false,
            verifyErrorMessage: '',
            verifyErrorModal: null,

            nextBtn: 'Next',

            isNextBtnLoading: false,

            // isValid allow step 5
            isApplyValid: false,
            isCollapse: false,
            quoteVerify: null,

            validBroker: true,
            ref: queryParams.get('ref') || '',

            // showSummaryComponent: true,
            showMemberCardComponent: false,

            quoteDataResponse: null,
            submitFormHandler: null,

            contactUsModal: null,
            timeoutModal: null,
            closingModal: null,
            contactUsData: {
                email: '',
                name: '',
                age: '',
                residenceCountryId: '',
                countryCodeId: '',
                number: '',
                contactTime: '',
            },

            summary: null,
        }
    },
    computed: {
        showStep4() {
            const numberInsuredMember =
                this.$formData.familyMembers.length + this.$formData.policyDetails.policyHolderInsured ? 1 : 0

            if (this.$formData.underwritingQuestionsCount != 0) {
                return true
            }

            return this.$formData.underwritingTypeId == 1 && numberInsuredMember > 0
        },
        isDisablePrevious() {
            if (
                this.$root.paymentStatus === 'MORGAN_PRICE_PAYMENT_ACCEPTED' ||
                this.$state.isApplyOrPaymentComplete ||
                this.$state.isSubmitFormProcessing
            ) {
                return true
            }
            return false
        },
    },
    watch: {},
    created() {
        let startTime = storage.getSession('startTime')

        if (!startTime) {
            startTime = helper.getTimestamps()
            storage.setSession('startTime', startTime)
        }

        this.$startTime = startTime
    },
    mounted() {
        let broker = this.$broker
        if (broker == null && this.ref != '') {
            this.validBroker = false
        }

        this.contactUsModal = new window.bootstrap.Modal(document.getElementById('contactUsModal'), {})
        this.timeOutModal = new window.bootstrap.Modal(document.getElementById('timeOutModal'), {})
        this.closingModal = new window.bootstrap.Modal(document.getElementById('closingModal'), {})

        storage.setSession('policyHolderInsured', this.$formData.policyDetails.policyHolderInsured || true)
        // Listen to events from the payment redirection pages when a payment
        // is accepted, declined, exception, cancelled.
        //window.addEventListener('storage', storageEvent(e))
        this.isTimeOut()

        // Listen when user closing the tab
        window.addEventListener('beforeunload', this.showModalBeforeClose)
    },
    beforeDestroy() {
        window.removeEventListener('onbeforeunload', this.showModalBeforeClose)
    },
    methods: {
        showModalBeforeClose(e) {
            // e.preventDefault()
            this.closingModal.toggle()
            // e.returnValue = ''
        },

        async getUnderwritingQuestions() {
            const getParam = new URLSearchParams([
                ['productId', this.$formData.product.productId],
                ['underwritingTypeId', this.$formData.underwritingTypeId],
                ['culture', this.$locale],
                ['selectedDate', this.$formData.policyDetails.policyStartDate],
            ])

            try {
                let resp = await baseApi.get(`api/underwritingQuestions?${getParam}`)
                this.$formData.underwritingQuestionsCount = resp ? resp.length : 0
            } catch (error) {
                this.$toast.open({
                    message: error,
                    type: 'error',
                })
            }
        },

        isTimeOut() {
            const isTimeOut = helper.checkTimeOut(this.$startTime, window.appSubmitLimitTime)
            if (this.$state.isApplyOrPaymentComplete === false && isTimeOut) {
                this.timeOutModal.toggle()
                return true
            }
        },

        openContactUsModal() {
            this.contactUsData.email = this.$formData.policyHolder.contactDetails.emailAddress
            this.contactUsData.name = `${this.details.forename} ${this.details.surname}`
            this.contactUsData.age = helper.getAge(new Date(this.details.dateOfBirth))
            this.contactUsData.residenceCountryId = this.$optionData.residenceCountries.find(
                (c) => c.value === this.details.residenceCountryId,
            ).value
            this.contactUsData.countryCodeId = this.$optionData.countryCodes.find(
                (c) => c.value === this.details.residenceCountryId,
            ).value
            this.contactUsModal.toggle()
        },

        formatContactUsEmailBody() {
            return (
                encodeURI(this.contactUsData.name).replace(/%20/g, ' ') +
                '|' +
                this.contactUsData.email +
                '|' +
                encodeURI(this.contactUsData.age).replace(/%20/g, ' ') +
                '|' +
                encodeURI(
                    this.$optionData.residenceCountries.find((c) => c.value === this.contactUsData.residenceCountryId)
                        .text,
                ).replace(/%20/g, ' ') +
                '|' +
                encodeURI(
                    this.$optionData.countryCodes.find((c) => c.value === this.contactUsData.residenceCountryId).text +
                        this.contactUsData.number,
                ).replace(/%20/g, ' ') +
                '|' +
                this.contactUsData.contactTime
            )
        },

        startOverFunction() {
            sessionStorage.clear()
            const currentUrl = window.location.href

            window.open(currentUrl, '_blank')
            window.close()
        },

        async sendContactUs() {
            var request = {
                EmailFor: 'quickquote',
                Subject: '[' + this.contactUsData.email + '] -  Apply Online Quote Contact Request',
                IsBodyHtml: true,
                EmailBody: this.formatContactUsEmailBody(),
            }

            try {
                await baseApi.post('api/sendContactUsEmail', request)
            } catch (err) {
                console.error(err)
            }
        },

        async getScreenShotPdf() {
            await this.$refs.html2Pdf.generatePdf()
        },

        async beforeDownloadScreenShot({ html2pdf, options, pdfContent }) {
            await html2pdf()
                .set(options)
                .from(pdfContent)
                .toPdf()
                .get('pdf')
                .then((pdf) => {
                    let pdfScreenshot = {
                        fileName: options.filename,
                        base64: btoa(pdf.output()),
                        contentType: 'application/octet-stream',
                    }

                    // save screen shot file to storage
                    Object.assign(this.$screenshot, pdfScreenshot)
                    this.$eventBus.$emit('screenshot-completed')
                })
        },

        async actionScreenShot(callback) {
            this.$root.showSummaryComponent = true

            this.submitFormHandler = () => {
                this.$root.showSummaryComponent = false
                this.$eventBus.$off('screenshot-completed', this.submitFormHandler)
                callback()
            }

            setTimeout(() => {
                this.getScreenShotPdf()
            }, 50)

            this.$eventBus.$on('screenshot-completed', this.submitFormHandler)
        },

        async getMemberCardPdf() {
            await this.$refs.html2PdfMemberCard.generatePdf()
        },

        async beforeDownloadMemberCard({ html2pdf, options, pdfContent }) {
            self = this
            await html2pdf()
                .set(options)
                .from(pdfContent)
                .toPdf()
                .get('pdf')
                .then((pdf) => {
                    let pdfScreenshot = {
                        fileName: options.filename,
                        base64: btoa(pdf.output()),
                        contentType: 'application/octet-stream',
                    }
                    // save screen shot file to storage

                    self.$memberCard = pdfScreenshot
                    // Object.assign(this.$memberCard, pdfScreenshot)
                    self.$eventBus.$emit('getMemberCard-completed')
                })
        },

        async actionGetMemberCard(callback) {
            this.showMemberCardComponent = true

            self = this
            const submitFormHandler = () => {
                self.showMemberCardComponent = false
                self.$eventBus.$off('getMemberCard-completed', submitFormHandler)
                callback(self.$memberCard)
            }

            this.$eventBus.$on('getMemberCard-completed', submitFormHandler)

            this.getMemberCardPdf()
        },

        validateForm(validate) {
            if (this.ignoreValidation) {
                return Promise.resolve(true)
            }

            return validate()
        },

        async goToNextStep(validate) {
            let isvalid = await this.validateForm(validate)
            storage.setSession('endTime', helper.getTimestamps())

            this.$endTime = storage.getSession('endTime')

            if (!isvalid) {
                // Scroll to first error input
                this.scrollToFirstError()
                return
            }

            const isTimeOut = this.isTimeOut()
            if (isTimeOut) return

            //validate step 1
            if (this.currentStep === 1) {
                try {
                    if (
                        this.$formData.policyDetails.policyHolderInsured == false &&
                        this.$formData.familyMembers.length == 0
                    ) {
                        this.$toast.open({
                            message: 'Please add family members',
                            type: 'error',
                        })
                        return
                    }

                    this.isNextBtnLoading = true
                    let quote = await quoteService.getQuoteAsync(this.$formData, this.$optionData, this.$locale)

                    Object.assign(this.$quote, quote)

                    //this.setInsuredIds()

                    this.$quote.products = quote.products
                    storage.clearSession(STORAGE.QUOTE)
                    storage.setSession(STORAGE.QUOTE, this.$quote)
                    // storage.setSession("insuredId", quote.insureds[0].insuredID)

                    // Set default product selected
                    if (this.$formData.selectedProductIndex != 0) {
                        this.$formData.selectedProductIndex = 0
                    }

                    // reset product when new quote
                    var defaultProduct = setDefaultProductFormData()
                    Object.assign(this.$formData.product, defaultProduct)
                    setSessionFormData(this.$formData.getCurrentFormData())

                    this.isNextBtnLoading = false
                    // if quote haven't product => return
                    if (this.$quote.products.length === 0) {
                        this.openContactUsModal()
                        return
                    }

                    var policyHolder = new Set()
                    policyHolder.details = this.$formData.policyHolder.details
                    policyHolder.contactDetails = this.$formData.policyHolder.contactDetails

                    helper.logStepTimestamps(1, this.$startTime, this.$endTime)

                    helper.stepLogs('step1', {
                        brokerRef: this.$broker ? this.$broker.brokerRef : '',
                        brokerName: this.$broker ? this.$broker.brokerCompanyName : '',
                        policyHolder,
                        familyMembers: this.$formData.familyMembers,
                        policyDetails: this.$formData.policyDetails,
                    })

                    this.setDefaultProductSelected(this.$quote.products[0])
                    logger.setLog(this.$root.statusStepLogs, this.currentStep)
                } catch (e) {
                    this.isNextBtnLoading = false
                    this.openContactUsModal()
                    logger.setLog(this.$root.statusStepLogs, this.currentStep, e)
                    return
                }
            }

            //validate step 2
            if (this.currentStep === 2) {
                var isValidProduct = this.validateProductSelected()

                //not allow next step if invalid
                if (!isValidProduct) {
                    return
                }

                helper.logStepTimestamps(2, this.$startTime, this.$endTime)

                helper.stepLogs('step2', {
                    brokerRef: this.$broker ? this.$broker.brokerRef : '',
                    brokerName: this.$broker ? this.$broker.brokerCompanyName : '',
                    product: this.$formData.product,
                    underwritingTypeId: this.$formData.underwritingTypeId,
                })

                this.getUnderwritingQuestions()

                logger.setLog(this.$root.statusStepLogs, this.currentStep)
                this.$root.callUpdateQuote()
            }

            //validate step 3
            if (this.currentStep === 3 && !this.showStep4) {
                this.isNextBtnLoading = true

                await this.getInsurerDetails()

                // helper.logStepTimestamps(3, this.$startTime, this.$endTime)

                // helper.stepLogs('step3', {
                //     brokerRef: this.$broker ? this.$broker.brokerRef : '',
                //     brokerName: this.$broker ? this.$broker.brokerCompanyName : '',
                //     policyHolder: this.$formData.policyHolder,
                //     familyMembers: this.$formData.familyMembers,
                // })

                try {
                    const res = await this.verifyData()
                    this.quoteVerify = res

                    if (this.$formData.policyDetails.policyStartDate == null)
                        this.$formData.policyDetails.policyStartDate = sessionStorage.getItem('selectedDate')

                    this.$forceUpdate()

                    if (res.underwritingSucceeded) {
                        this.isApplyValid = true
                    } else {
                        this.isApplyValid = false
                    }

                    logger.setLog(this.$root.statusStepLogs, this.currentStep)
                    this.goToStep(this.currentStep + 2)
                } catch (e) {
                    this.isApplyValid = false
                    this.openContactUsModal()
                    logger.setLog(this.$root.statusStepLogs, this.currentStep, e)
                    return
                } finally {
                    this.isNextBtnLoading = false
                }

                this.scrollToTop()
                return
            }

            //validate step 4
            if (this.currentStep === 4) {
                this.isNextBtnLoading = true

                await this.getInsurerDetails()

                helper.logStepTimestamps(4, this.$startTime, this.$endTime)

                try {
                    let res = await this.verifyData()
                    this.quoteVerify = res
                    this.$forceUpdate()
                    if (res.underwritingSucceeded) {
                        this.isApplyValid = true
                    } else {
                        this.isApplyValid = false
                    }

                    let familyMember_underwritingQuestions = []
                    let familyMembers = this.$formData.familyMembers

                    if (familyMembers) {
                        familyMembers.map((e) => {
                            familyMember_underwritingQuestions.push({
                                name: e.details.forename + ' ' + e.details.surname,
                                underwritingQuestions: e.underwritingQuestions,
                            })
                        })
                    }

                    await helper.stepLogs('step4', {
                        brokerRef: this.$broker ? this.$broker.brokerRef : '',
                        brokerName: this.$broker ? this.$broker.brokerCompanyName : '',
                        underwritingQuestions: this.$formData.underwritingQuestions,
                        familyMember_underwritingQuestions,
                        timestamps: helper.getElapsedTime(this.$startTime, this.$endTime),
                    })

                    logger.setLog(this.$root.statusStepLogs, this.currentStep)
                } catch (error) {
                    this.isApplyValid = false
                    this.openContactUsModal()
                    logger.setLog(this.$root.statusStepLogs, this.currentStep, error)
                    return
                }

                this.isNextBtnLoading = false
                // return
            }

            if (this.currentStep !== 3 || this.showStep4) {
                this.goToStep(this.currentStep + 1)
            }
        },

        setStatusStep(currentStep) {
            switch (currentStep) {
                case 1:
                    this.$stepStatus.step1 = true
                    break
                case 2:
                    this.$stepStatus.step2 = true
                    break
                case 3:
                    this.$stepStatus.step3 = true
                    break
                case 4:
                    this.$stepStatus.step4 = true
                    break
                case 5:
                    this.$stepStatus.step5 = true
                    break
                default:
                    break
            }

            storage.setSession(STORAGE.STEP_STATUS, this.$stepStatus)
        },

        getStatusStep(currentStep) {
            switch (currentStep) {
                case 1:
                    return true
                case 2:
                    return this.$stepStatus.step2
                case 3:
                    return this.$stepStatus.step3
                case 4:
                    return this.$stepStatus.step4
                case 5:
                    return this.$stepStatus.step5
                default:
                    return false
            }
        },

        goToPreviousStep() {
            if (this.$formData.policyDetails.policyStartDate) {
                if (this.currentStep === 5 && !this.showStep4) {
                    this.goToStep(this.currentStep - 2)
                    return
                }

                // Back to step 2
                if (this.currentStep === 3) {
                    // Refresh QuoteData
                    setTimeout(() => {
                        this.$emit('update-quote')
                    }, 500)
                }
                this.goToStep(this.currentStep - 1)
            }
        },

        goToStep(step) {
            this.setStatusStep(this.currentStep)
            this.previousStep = this.currentStep
            this.currentStep = step
            this.$formData.currentStep = step
            setSessionFormData(this.$formData.getCurrentFormData())
            this.updateQueryParams({ step: step })
            this.scrollToTop()
        },

        updateQueryParams(params) {
            const url = new URL(window.location)
            Object.keys(params).forEach((key) => {
                url.searchParams.set(key, params[key])
            })
            window.history.pushState({}, '', url)
        },
        scrollToTop() {
            setTimeout(() => {
                this.$root.$el.scrollIntoView({ behavior: 'smooth' })
            }, 100)
        },

        setInsuredIds() {
            // Set insuredId's into this.$formData START.
            if (this.$quote.insureds) {
                const assignedInsuredIds = new Set()
                let insureds = this.$quote.insureds

                this.$formData.familyMembers.forEach((familyMember) => {
                    const matchingInsured = insureds.find((insured) => {
                        return (
                            !insured.isAPolicyHolder &&
                            !assignedInsuredIds.has(insured.insuredID) &&
                            familyMember.details.nationalityCountryId === insured.nationality.countryID &&
                            helper.getAge(new Date(familyMember.details.dateOfBirth)) === insured.age
                        )
                    })

                    if (matchingInsured) {
                        familyMember.details.insuredId = matchingInsured.insuredID
                        if (!assignedInsuredIds.has(matchingInsured.insuredID)) {
                            assignedInsuredIds.add(matchingInsured.insuredID)
                        }
                    }
                })

                insureds.forEach((insured) => {
                    if (insured.isAPolicyHolder && !assignedInsuredIds.has(insured.insuredID)) {
                        this.$formData.policyHolder.details.insuredId = insured.insuredID
                        assignedInsuredIds.add(insured.insuredID)
                    }
                })
            }
            // Set insuredId's into this.$formData END.
        },

        async verifyData() {
            this.setInsuredIds()

            const summary = getSummaryData(this)

            this.summary = summary
            // mapping data
            if (!summary.voluntaryExcessSelected) {
                console.error('Please select voluntaryExcess')
            } else {
                this.productData.selectedExcessId = summary.voluntaryExcessSelected.voluntaryExcessID
            }

            if (!summary.coInsuranceSelected) {
                console.error('Please select coInsurance')
            } else {
                this.productData.coInsuranceSelectedId = summary.coInsuranceSelected.map((v) => v.coInsureId) || null
            }

            this.productData.additionalBenefitSelectedListId =
                summary.additionalBenefitsSelected.map((b) => {
                    return b.benefitID
                }) || null

            if (!this.$formData.policyDetails.policyHolderInsured) {
                this.$formData.policyHolder.additionalDetails.physicianDetails = null
            }

            const formData = this.$formData.getCurrentFormData()

            let verifyInp = {
                quote: JSON.parse(JSON.stringify(this.$quote)),
                formData: JSON.parse(JSON.stringify(formData)),
                culture: this.$locale,
            }

            // ignore false question of policy holder & family
            // verifyInp.formData.underwritingQuestions = verifyInp.formData.underwritingQuestions.filter((q) => q.isAnswer)

            // if (verifyInp.formData.familyMembers.length > 0) {
            // 	verifyInp.formData.familyMembers.forEach((f) => {
            // 		f.underwritingQuestions = f.underwritingQuestions.filter((q) => q.isAnswer)
            // 	})
            // }

            try {
                this.quoteDataResponse = await baseApi.post('api/verifyQuote', verifyInp)
            } catch (e) {
                // this.$toast.open({
                //   message: 'VerifyQuote has error',
                //   type: 'error',
                // })
            }

            return this.quoteDataResponse
        },
        async getQuoteRequestData() {
            const summary = getSummaryData(this)
            // mapping data
            if (!summary.voluntaryExcessSelected) {
                console.error('Please select voluntaryExcess')
            } else {
                this.productData.selectedExcessId = summary.voluntaryExcessSelected.voluntaryExcessID
            }

            if (!summary.coInsuranceSelected) {
                console.error('Please select coInsurance')
            } else {
                this.productData.coInsuranceSelectedId = summary.coInsuranceSelected.map((v) => v.coInsureId) || null
            }

            this.productData.additionalBenefitSelectedListId =
                summary.additionalBenefitsSelected.map((b) => {
                    return b.benefitID
                }) || null

            let verifyInp = {
                quote: JSON.parse(JSON.stringify(this.$quote)),
                formData: JSON.parse(JSON.stringify(this.$formData.getCurrentFormData())),
                culture: this.$locale,
            }

            // ignore false question of policy holder & family
            verifyInp.formData.underwritingQuestions = verifyInp.formData.underwritingQuestions.filter(
                (q) => q.isAnswer,
            )

            if (verifyInp.formData.familyMembers.length > 0) {
                verifyInp.formData.familyMembers.forEach((f) => {
                    f.underwritingQuestions = f.underwritingQuestions.filter((q) => q.isAnswer)
                })
            }
            return await baseApi.post('api/getQuoteData', verifyInp)
        },
        validateProductSelected() {
            if (this.productData.levelOfCoverId === -1) {
                this.$toast.open({
                    message: this.$t('notify.selectPackage'),
                    type: 'error',
                })
                return false
            }

            if (this.productData.productId === -1) {
                this.$toast.open({
                    message: this.$t('notify.selectProduct'),
                    type: 'error',
                })
                return false
            }
            if (this.$formData.underwritingTypeId === '') {
                this.$toast.open({
                    message: this.$t('notify.selectUnderwritingType'),
                    type: 'error',
                })
                return false
            }

            return true
        },
        scrollToFirstError() {
            const errorItems = document.getElementsByClassName('input-error')
            if (errorItems.length > 0) {
                const firstErrorElement = this.getFirstNodeName(errorItems[0].parentElement, ['INPUT', 'SELECT'])
                if (firstErrorElement) {
                    firstErrorElement.focus()
                    this.$toast.open({
                        message: helper.multiLanguageDisplay(this.$root.t('notify.fillRequiredField')),
                        type: 'error',
                    })
                }
            }
        },
        getFirstNodeName(node, nodeNames) {
            if (nodeNames.indexOf(node.nodeName) >= 0) return node

            if (node.childNodes.length > 0) {
                const childNodes = Array.from(node.childNodes)
                for (var i = 0; i < childNodes.length; i++) {
                    let hasNode = this.getFirstNodeName(childNodes[i], nodeNames)
                    if (hasNode) {
                        return hasNode
                    }
                }
            }
            return null
        },
        setDefaultProductSelected(product) {
            this.$formData.product.productId = product.productID
        },
        async copyRequestJsonToClipboard() {
            let quoteData = await this.getQuoteRequestData()
            if (quoteData === null) {
                await this.$toast.open({
                    message: 'Value is null, click Verify to get data!',
                    type: 'error',
                })
                return
            }
            navigator.clipboard.writeText(JSON.stringify(quoteData))
            await this.$toast.open({
                message: 'Copied!',
                type: 'success',
            })
        },
        async getInsurerDetails() {
            try {
                const summary = getSummaryData(this)
                const res = await applyOnlineService.getInsurerDetailsAsync(
                    summary.productSelected.productID,
                    summary.productSelected.productName,
                    this.$formData.policyDetails.policyStartDate,
                )

                let insurerCompanyName = ''
                if (
                    res &&
                    res.insurerCompanyDetailsJson &&
                    res.insurerCompanyDetailsJson.insurerAddress &&
                    res.insurerCompanyDetailsJson.insurerAddress.length > 0
                ) {
                    insurerCompanyName = res.insurerCompanyDetailsJson.insurerAddress[0]
                }

                storage.setSession('insurerId', res.insurerCompanyId)
                storage.setSession('insurerCompanyName', insurerCompanyName)
            } catch (error) {
                console.error(error)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.form-footer {
    position: sticky;
    bottom: 0;
    padding: 16px;
    background-color: white;
}

@media screen and (max-width: 600px) {
    .form-footer {
        padding: 5px;
    }
}

.container {
    margin-top: 1em;
}

.bg-footer {
    background: rgba($color: #fff, $alpha: 1);
}

.fixed-button {
    position: fixed;
    top: 10px;
    right: 10px;
}
</style>
